module.exports = __webpack_public_path__ + "img/step-1-img@2x.png";